import {Routes} from '@angular/router';
import {StandardTitleComponent} from './standard-title.component';

export const STANDARD_TITLE_ROUTES: Routes = [
  { path: '', component: StandardTitleComponent },
  { path: ':id/modify', component: StandardTitleComponent },
  { path: 'create', component: StandardTitleComponent }
];
